import { render } from "./niiShow.vue?vue&type=template&id=5f983898"
import script from "./niiShow.vue?vue&type=script&lang=js"
export * from "./niiShow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__